import configs from './config.json';
import Axios from 'axios';

export class Api {

    static checkConnection = async (response, error) => {
        await Axios.get(`${configs.server.Api}/${configs["check-connection"]}`, {})
            .then(result => {
                response(result)
            })
            .catch(e => this.defaultErrorHandler(e, error));
    }

    static post = async (url, data, response, header = configs.requestHeader, errorHandler) => {
        await Axios.post(`${configs.server.Api}/${url}`, data, {headers: header}).then(result => {
            response(result);
        }).catch((error) => {
            // if (error.response) {
            //     // The request was made and the server responded with a status code
            //     // that falls out of the range of 2xx
            //     console.log(error.response.data);
            //     console.log(error.response.status);
            //
            //     console.log(error.response.headers);
            // } else if (error.request) {
            //     // The request was made but no response was received
            //     // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            //     // http.ClientRequest in node.js
            //     console.log(error.request);
            // } else {
            //     // Something happened in setting up the request that triggered an Error
            //     console.log('Error', error.message);
            // }
            // console.log(error.config);
            this.defaultErrorHandler(error, errorHandler)
        });
    };


    static get = async (url, data, response, header = configs.requestHeader, errorHandler) => {


        await Axios.get(`${configs.server.Api}/${url}`, {headers: header})
            .then(result => {
                response(result)
            })
            .catch(e => this.defaultErrorHandler(e, errorHandler));

    };


    static put = (url, data, res, header = configs.requestHeader, errorHandler) => {
        data.append('_method', 'PUT');
        Axios.post(`${configs.server.Api}/${url}`, data, {headers: header}).then(result => {
            res(result)
        }).catch(e => this.defaultErrorHandler(e, errorHandler));
    };
    static delete = (url, data, res, header = configs.requestHeader, handleError = this.defaultErrorHandler) => {
        Axios.delete(`${configs.server.Api}/${url}/${data ? data : ''}`, {headers: header}).then(result => {
            res(result)
        }).catch(e => handleError(e));
    }
    static  defaultErrorHandler = (error, errorHandler) => {
        // console.log(error.response.status);
        errorHandler(error);
        if (error.response) {
            switch (error.response.status % 100) {
                case 4:

                    break;
                case 500:

                    break;

                default:

            }
        } else if (error.request) {
            this.connectionError();
        } else {

        }
    }

    static  error404 = () => {
        this.goTo("/404");
    }

    static error500 = () => {
        this.goTo("/500");
    }

    static connectionError = () => {

    }

    static goTo = (address) => {
        // this.#history.push(address);
    }
}
